import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useProfileContext } from "../contexts/ProfileContext";
import { Role } from "../core/models/entities/Role";

interface Props {
  element: JSX.Element;
}

export default function CartRoute({ element }: Props): ReactElement {
  const { role, organization } = useProfileContext();

  if (role === Role.EndUser && organization?.hidePrices) {
    return <Navigate to="/" replace />;
  }
  return element;
}
